import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';



export const useGetWarehouseList = (lcrId) => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const dispatch = useDispatch();

  return useQuery(
    ['warehouseList', lcrId],
    () => axiosInstance.get(liveCleanroom(orgId).listWarehouses(lcrId)),
    {
      select: (response) => response.data?.liveCleanRoomWarehouses || [],
      onError: (error) => {
        dispatch(
          showAlert({
            message: error.response?.data?.message || 'Error fetching warehouse list',
            type: 'error',
          }),
        );
      },
    },
  );
};


